import type { DrawnDynamic } from './drawn';
import { SMUFL } from './smufl';

// Bravura glyphBBoxes and glyphAdvanceWidths, in staff spaces. Runs are
// centred on their combined advance, including the overhang of italic f/p.
const metrics: Record<
  number,
  { advance: number; left: number; right: number; top: number; bottom: number }
> = {
  [SMUFL.dynamicPiano]: { advance: 1.46, left: -0.356, right: 1.464, top: -1.096, bottom: 0.568 },
  [SMUFL.dynamicMezzo]: { advance: 1.748, left: -0.08, right: 1.784, top: -1.096, bottom: 0.04 },
  [SMUFL.dynamicForte]: { advance: 1.456, left: -0.564, right: 1.456, top: -1.776, bottom: 0.608 },
  [SMUFL.dynamicPP]: { advance: 2.908, left: -0.328, right: 2.912, top: -1.096, bottom: 0.568 },
  [SMUFL.dynamicMP]: { advance: 3.304, left: -0.08, right: 3.3, top: -1.096, bottom: 0.568 },
  [SMUFL.dynamicMF]: { advance: 3.188, left: -0.08, right: 3.272, top: -1.724, bottom: 0.66 },
  [SMUFL.dynamicFF]: { advance: 2.436, left: -0.54, right: 2.44, top: -1.776, bottom: 0.608 },
};

/** Ink relative to the centre/baseline of a rendered dynamic glyph run. */
export function dynamicBounds(d: Pick<DrawnDynamic, 'glyphs'>) {
  if (!d.glyphs.length) return { left: 0, right: 0, top: 0, bottom: 0 };
  let advance = 0,
    left = Infinity,
    right = -Infinity,
    top = Infinity,
    bottom = -Infinity;
  for (const cp of d.glyphs) {
    const m = metrics[cp] ?? { advance: 4, left: 0, right: 4, top: -4, bottom: 4 };
    left = Math.min(left, advance + m.left);
    right = Math.max(right, advance + m.right);
    top = Math.min(top, m.top);
    bottom = Math.max(bottom, m.bottom);
    advance += m.advance;
  }
  return { left: left - advance / 2, right: right - advance / 2, top, bottom };
}
